<template>
  <div class="user-lists">
    <ul>
      <li v-for="item in userLists" :key="item.id">
        {{ item.name }} ====== {{ item.email }} / [{{ item.type }}] /
        {{ item.password }}
      </li>
    </ul>
  </div>
</template>

<script>
import { getAdminUsers } from '../../api/admin'
export default {
  name: 'user-lists',
  data() {
    return {
      userLists: []
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      getAdminUsers().then(data => {
        console.log('admin user users:', data)
        this.userLists = data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-lists {
  display: block;
  ul li {
    margin: 20px 0;
  }
}
</style>
